const MetaJSON = {
  "close": false,
  "id": "AnalogExcerptRequest",
  "enabled": true,
  "title": {"ru": "Выписка в бумажном виде"},
  "sections": [{
    "id": "GeneralInformation",
    "title": {"ru": "Выписка в бумажном виде"},
    "controls": [{
      "type": "Number",
      "id": "ORN",
      "contentNumb": "1",
      "title": {"ru": "ОРН"},
      "required": true,
      "disabled": true,
      "extra": {"init": "ORN"},
      "order": 1
    }, {
      "type": "DropBox",
      "id": "obtaining",
      "contentNumb": "2",
      "title": {"ru": "Способ получения"},
      "required": true,
      "disabled": false,
      "order": 2,
      "options": [{"value": {"ru": "По почте (Почта России)"}, "key": 1}, {"value": {"ru": "Нарочным"}, "key": 2}]
    }, {
      "type": "TextArea",
      "id": "Address",
      "contentNumb": "3",
      "title": {"ru": "Почтовый адрес"},
      "required": true,
      "maxLength": 1000,
      "lines": 3,
      "visible": [{"field": "obtaining", "rule": "has_value", "values": ["1"]}],
      "order": 3
    }, {
      "type": "Label",
      "id": "pickupTooltip",
      "contentNumb": "7",
      "title": {"ru": "<h6>Адрес, по которому можно получить выписку:</h6><br>г. Москва, ул. Нобеля, д. 5."},
      "visible": [{"field": "obtaining", "rule": "has_value", "values": ["2"]}],
      "order": 3
    }, {
      "type": "TextBox",
      "id": "FIO",
      "contentNumb": "4",
      "title": {"ru": "ФИО"},
      "required": true,
      "disabled": false,
      "maxLength": 255,
      "order": 4
    }, {
      "type": "TextBox",
      "id": "phone",
      "contentNumb": "5",
      "title": {"ru": "Телефон"},
      "required": false,
      "disabled": false,
      "maxLength": 255,
      "order": 5
    }]
  }]
};

export default MetaJSON;
